import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export interface NoveltySearchStorageData {
    techEssential: string;
    pbdStart: string;
    pbdEnd: string;
}

const STORAGE_KEY = 'novelty-search-input-data';

/**
 * Novelty search 存储服务
 * 用于在 domain 层处理从首页传递过来的搜索数据
 */
export interface NoveltySearchStorageService {
    getStorageData(): NoveltySearchStorageData | null;
    hasStorageData(): boolean;
    clearStorageData(): void;
}

@injectable()
export class NoveltySearchStorageServiceImpl implements NoveltySearchStorageService {
    /**
     * 读取存储的搜索数据
     */
    getStorageData(): NoveltySearchStorageData | null {
        try {
            const data = localStorage.getItem(STORAGE_KEY);
            if (!data) {
                return null;
            }
            return JSON.parse(data) as NoveltySearchStorageData;
        }
        catch (error) {
            console.error('Failed to parse novelty search storage data:', error);
            return null;
        }
    }

    /**
     * 检查是否有存储的数据
     */
    hasStorageData(): boolean {
        const data = this.getStorageData();
        return data !== null && data.techEssential !== '';
    }

    /**
     * 清空存储的数据
     */
    clearStorageData(): void {
        localStorage.removeItem(STORAGE_KEY);
    }
}

export const NoveltySearchStorageService = Symbol.for('NoveltySearchStorageService');
